import React from "react";
import LoadingButton from "../../../components/common/LoadingButton";
import AuthTermsCheckbox from "./AuthTermsCheckbox";
import { AUTH_INPUT_CLASS } from "./authFieldStyles";

/**
 * Shared email + optional terms + magic-link submit.
 */
export default function AuthMagicLinkForm({
  email,
  onEmailChange,
  terms,
  onTermsChange,
  onSubmit,
  loading = false,
  disabled = false,
  termsVariant = "signup",
  emailId = "magic-email",
  submitLabel = "Email me a sign-in link",
  loadingLabel = "Sending…",
  showTerms = true,
  error = "",
  buttonClassName = "w-full rounded-lg bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white disabled:opacity-50",
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-3.5">
      <label className="block text-sm font-medium text-slate-800" htmlFor={emailId}>
        Email
        <input
          id={emailId}
          name="email"
          type="email"
          required
          value={email}
          onChange={onEmailChange}
          placeholder="you@example.com"
          className={AUTH_INPUT_CLASS}
          autoComplete="email"
        />
      </label>
      {showTerms ? (
        <AuthTermsCheckbox
          terms={terms}
          setTerms={onTermsChange}
          variant={termsVariant}
        />
      ) : null}
      {error ? (
        <div className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800">
          {error}
        </div>
      ) : null}
      <LoadingButton
        type="submit"
        loading={loading}
        loadingLabel={loadingLabel}
        disabled={disabled}
        invert
        className={buttonClassName}
      >
        {submitLabel}
      </LoadingButton>
    </form>
  );
}
